export default "__VITE_ASSET__BpL2fJT9__"